// extracted by mini-css-extract-plugin
export default {"inputs_container":"MainForm_inputs_container__XKbbj"};